import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../services/app.service';
import { ScrudgRevisionService } from '../../../../services/base/scrudg-revision/scrudg-revision.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.css']
})

export class TaskComponent implements OnInit {

    public constructor(public route: ActivatedRoute) {

        const parameters = this.route.params;
        let taskId: number = 0;

        if (parameters != null) {

            parameters.subscribe((p) => {

                taskId = p["id"];
            });
        }
    }

    public ngOnInit(): void {

        alert("Hi Eli, this is ngOnInit talking");
    }
}
